import { render } from "./AllesSortieren.vue?vue&type=template&id=3f22e421&scoped=true"
import script from "./AllesSortieren.vue?vue&type=script&lang=js"
export * from "./AllesSortieren.vue?vue&type=script&lang=js"

import "./AllesSortieren.vue?vue&type=style&index=0&id=3f22e421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f22e421"]])

export default __exports__